export default "__VITE_ASSET__zrnbDGdm__"